/* BABINES — interactions propres à chaque page (accueil, fiche produit, La bande, duo, tailles, FAQ, formulaires).
   Chaque module s'active seulement si son élément racine est présent, et s'appuie sur window.Babines (assets/babines.js). */
(function () {
  'use strict';
  var B = window.Babines;
  if (!B) return;
  var qsa = B.qsa, esc = B.esc, fmt = B.fmt;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function once(el, key) { if (el['_b' + key]) return false; el['_b' + key] = true; return true; }
  function isMobile() { return window.innerWidth < 900; }
  function mix(a, b, k) {
    var p = function (h) { return [1, 3, 5].map(function (i) { return parseInt(h.slice(i, i + 2), 16); }); };
    var A = p(a), C = p(b);
    return '#' + A.map(function (v, i) { return Math.round(v + (C[i] - v) * k).toString(16).padStart(2, '0'); }).join('');
  }
  function limitsOf(str) {
    var l = String(str || '').split(',').map(function (x) { return parseFloat(x); }).filter(function (x) { return !isNaN(x); });
    return l.length ? l : [160, 170, 180, 190];
  }
  /* Taille estimée : index dans la liste des tailles d'après les seuils */
  function guessIndex(h, limits) { for (var i = 0; i < limits.length; i++) if (h < limits[i]) return i; return limits.length; }

  /* ================= ACCUEIL · thermostat ================= */
  function initThermo(root) {
    qsa('[data-thermo]', root).forEach(function (el) {
      if (!once(el, 'thermo')) return;
      var stages = []; try { stages = JSON.parse(el.querySelector('[data-thermo-stages]').textContent); } catch (e) {}
      var input = el.querySelector('[data-thermo-input]');
      var canvas = el.querySelector('[data-thermo-snow]');
      var snow = canvas ? B.snow(canvas, { density: 34, min: 4, max: 9, speed: 1.6, colors: ['#FFFFFF', '#F2F6FA', '#D8E8F4'] }) : null;
      function set(t) {
        var k = (t + 3) / 24;
        var label = (t > 0 ? '+' : t < 0 ? '−' : '') + Math.abs(t) + ' °C';
        var idx = t < 3 ? 0 : t < 10 ? 1 : t < 17 ? 2 : 3;
        var stage = stages[Math.min(idx, stages.length - 1)] || { title: '', text: '' };
        var ink = k < 0.5 ? '#2F6890' : '#B4483E', fill = mix('#9DD0F0', '#F4978E', k);
        el.style.background = k < 0.5 ? mix('#D8E8F4', '#F2F6FA', k * 2) : mix('#F2F6FA', '#FFE9DC', (k - 0.5) * 2);
        qsa('[data-thermo-ink]', el).forEach(function (n) { n.style.color = ink; });
        el.querySelector('[data-thermo-temp]').textContent = label;
        el.querySelector('[data-thermo-stage-title]').textContent = stage.title;
        el.querySelector('[data-thermo-stage-text]').textContent = stage.text;
        var f = el.querySelector('[data-thermo-fill]'); f.style.width = 'calc((100% - 40px) * ' + k.toFixed(3) + ')'; f.style.background = fill;
        el.querySelector('[data-thermo-bulb]').style.background = fill;
        el.querySelector('[data-thermo-thumb]').style.left = 'calc(56px + (100% - 86px) * ' + k.toFixed(3) + ')';
        el.querySelector('[data-thermo-frost]').style.opacity = Math.max(0, 1 - k * 1.6);
        el.querySelector('[data-thermo-warm]').style.opacity = Math.max(0, k * 1.4 - 0.4);
        input.setAttribute('aria-valuetext', label);
        if (snow) { snow.setSpeed(Math.max(0.05, 1.6 * (1 - k * 1.1))); snow.setMelt(Math.max(0, Math.min(1, (k - 0.45) / 0.5))); }
      }
      var onInput = function () { set(Number(input.value)); };
      input.addEventListener('input', onInput); input.addEventListener('change', onInput);
      set(Number(input.value));
    });
  }

  /* ================= ACCUEIL · anatomie ================= */
  function initAnatomy(root) {
    qsa('[data-anatomy]', root).forEach(function (el) {
      if (!once(el, 'ana')) return;
      qsa('[data-anno-dot]', el).forEach(function (d) { d._base = d.style.transform.indexOf('translate') >= 0 ? 'translate(-50%,-50%) ' : ''; });
      function hover(n) {
        el.classList.toggle('is-hover', n != null);
        qsa('[data-anno]', el).forEach(function (li) { li.classList.toggle('is-on', li.getAttribute('data-anno') === String(n)); });
        qsa('[data-anno-dot]', el).forEach(function (d) { d.style.transform = d._base + 'scale(' + (d.getAttribute('data-anno-dot') === String(n) ? 1.35 : 1) + ')'; });
      }
      qsa('[data-anno]', el).forEach(function (li) {
        li.addEventListener('mouseenter', function () { hover(li.getAttribute('data-anno')); });
        li.addEventListener('mouseleave', function () { hover(null); });
      });
    });
  }

  /* ================= FORMULAIRES ================= */
  function setFieldError(form, name, msg) {
    var input = form.querySelector('[data-field="' + name + '"]'), p = form.querySelector('[data-error="' + name + '"]');
    if (input) input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (p) p.textContent = msg || '';
  }
  function initForms(root) {
    qsa('[data-newsletter]', root).forEach(function (form) {
      if (!once(form, 'nl')) return;
      var email = form.querySelector('[data-nl-email]'), err = form.querySelector('[data-nl-error]'), field = form.querySelector('[data-nl-field]');
      if (!email) return;
      function show(msg) { err.textContent = msg; email.setAttribute('aria-invalid', msg ? 'true' : 'false'); field.style.outline = msg ? '3px solid #1C2140' : 'none'; }
      email.addEventListener('input', function () { show(''); });
      form.addEventListener('submit', function (e) {
        var v = email.value.trim();
        if (!v) { e.preventDefault(); show('Il nous faut ton email. Même les monstres en ont un.'); email.focus(); return; }
        if (!EMAIL.test(v)) { e.preventDefault(); show('Cet email a l’air un peu gelé. Vérifie le @ et le point.'); email.focus(); }
      });
    });
    qsa('[data-contact-form]', root).forEach(function (form) {
      if (!once(form, 'contact')) return;
      qsa('[data-field]', form).forEach(function (i) { i.addEventListener('input', function () { setFieldError(form, i.getAttribute('data-field'), ''); }); });
      form.addEventListener('submit', function (e) {
        var get = function (n) { var i = form.querySelector('[data-field="' + n + '"]'); return i ? i.value.trim() : ''; };
        var er = {};
        if (!get('name')) er.name = 'On aime bien savoir à qui on parle.';
        if (!EMAIL.test(get('email'))) er.email = 'Cet email a l’air gelé. Vérifie le @ et le point.';
        if (get('msg').length < 5) er.msg = 'Un tout petit peu plus long, s’il te plaît.';
        ['name', 'email', 'msg'].forEach(function (n) { setFieldError(form, n, er[n] || ''); });
        var first = Object.keys(er)[0];
        if (first) { e.preventDefault(); var i = form.querySelector('[data-field="' + first + '"]'); if (i) i.focus(); }
      });
    });
    qsa('[data-suivi-form]', root).forEach(function (form) {
      if (!once(form, 'suivi')) return;
      qsa('[data-field]', form).forEach(function (i) { i.addEventListener('input', function () { setFieldError(form, i.getAttribute('data-field'), ''); }); });
      form.addEventListener('submit', function (e) {
        var o = form.querySelector('[data-field="order"]').value.trim(), m = form.querySelector('[data-field="email"]').value.trim();
        var oErr = o ? '' : 'Il nous faut ton numéro de commande.', eErr = EMAIL.test(m) ? '' : 'Cet email a l’air gelé.';
        setFieldError(form, 'order', oErr); setFieldError(form, 'email', eErr);
        if (oErr || eErr) e.preventDefault();
      });
    });
  }

  /* ================= FAQ · filtres par thème ================= */
  function initFaq(root) {
    qsa('[data-faq-page]', root).forEach(function (el) {
      if (!once(el, 'faq')) return;
      qsa('[data-faq-theme]', el).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-faq-theme');
          qsa('[data-faq-theme]', el).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          qsa('[data-faq-group]', el).forEach(function (g) { g.hidden = id !== 'all' && g.getAttribute('data-faq-group') !== id; });
        });
      });
    });
  }

  /* ================= GUIDE DES TAILLES ================= */
  function initTailles(root) {
    qsa('[data-tailles-page]', root).forEach(function (el) {
      if (!once(el, 'tailles')) return;
      var limits = limitsOf(el.getAttribute('data-limits'));
      var sils = qsa('[data-sil]', el), sizes = sils.map(function (s) { return s.getAttribute('data-sil'); });
      var input = el.querySelector('[data-tailles-height]'), guessEl = el.querySelector('[data-tailles-guess]'), errEl = el.querySelector('[data-tailles-error]');
      function mid(i) { return i === 0 ? limits[0] - 5 : i >= limits.length ? limits[limits.length - 1] + 5 : Math.round((limits[i - 1] + limits[i]) / 2); }
      function update() {
        var h = Number(input.value), valid = h >= 140 && h <= 210;
        var g = valid ? (sizes[Math.min(guessIndex(h, limits), sizes.length - 1)] || '?') : '?';
        guessEl.textContent = g;
        input.setAttribute('aria-invalid', valid ? 'false' : 'true');
        errEl.textContent = valid ? '' : 'Entre 140 et 210 cm, s’il te plaît. Même les monstres ont des limites.';
        sils.forEach(function (s) { var on = s.getAttribute('data-sil') === g; s.setAttribute('aria-pressed', on ? 'true' : 'false'); s.classList.toggle('is-neutral', !valid); });
        qsa('[data-tailles-row]', el).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-tailles-row') === g); });
      }
      sils.forEach(function (s, i) { s.addEventListener('click', function () { input.value = mid(i); update(); }); });
      input.addEventListener('input', update);
      update();
    });
  }

  /* ================= LA BANDE · filtre par taille + ajout ================= */
  function initBande(root) {
    qsa('[data-bande-page]', root).forEach(function (el) {
      if (!once(el, 'bande')) return;
      var size = null, note = el.querySelector('[data-bande-note]'), defaultNote = note ? note.textContent : '';
      function update() {
        qsa('[data-bande-size]', el).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-bande-size') === size ? 'true' : 'false'); });
        var avail = 0;
        qsa('[data-bande-add]', el).forEach(function (btn) {
          var id = btn.getAttribute('data-bande-add');
          var out = !!(size && B.PRODUCT && !B.available(id, size));
          if (size && !out) avail++;
          btn.textContent = !size ? 'Ajouter au panier' : out ? 'Épuisé en ' + size : 'Ajouter en ' + size;
          btn.disabled = out; btn.style.opacity = out ? '.5' : ''; btn.style.cursor = out ? 'not-allowed' : 'pointer';
        });
        if (note) note.textContent = size ? (B.PRODUCT ? avail + ' monstre' + (avail > 1 ? 's' : '') + ' disponible' + (avail > 1 ? 's' : '') + ' en ' + size : 'Tous les monstres en ' + size) : defaultNote;
        qsa('[data-bande-need]', el).forEach(function (p) { p.hidden = true; });
      }
      el.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bande-size]');
        if (t) { var s = t.getAttribute('data-bande-size'); size = size === s ? null : s; update(); return; }
        t = e.target.closest('[data-bande-add]');
        if (t) {
          var id = t.getAttribute('data-bande-add');
          if (!size) { qsa('[data-bande-need]', el).forEach(function (p) { p.hidden = p.getAttribute('data-bande-need') !== id; }); return; }
          B.cart.add({ id: id, size: size }, t).catch(function () {});
        }
      });
      update();
    });
  }

  /* ================= COMPOSE TON DUO ================= */
  function initDuo(root) {
    qsa('[data-duo-page]', root).forEach(function (el) {
      if (!once(el, 'duo')) return;
      var BAND = B.BAND, SIZES = B.SIZES;
      if (!BAND.length) return;
      var n = new URLSearchParams(location.search).get('n') === '3' ? 3 : 2, tried = false;
      var slots = [0, 1, 2].map(function (i) { return { id: BAND[i % BAND.length].id, size: null }; });
      var heads = el.querySelector('[data-duo-heads]'), box = el.querySelector('[data-duo-slots]');
      var ROT = ['-6deg', '5deg', '-3deg'];
      function build() {
        heads.innerHTML = slots.slice(0, n).map(function (s, i) {
          var b = B.byId(s.id);
          return '<div data-duo-head="' + i + '" style="width:clamp(96px,20vw,240px);aspect-ratio:1;margin-bottom:-14%;transform:rotate(' + ROT[i] + ');transition:transform .4s cubic-bezier(.3,1.6,.5,1)">' + B.mascotSVG(b.hex, b.tuft, '', true) + '</div>';
        }).join('');
        box.innerHTML = slots.slice(0, n).map(function (s, i) {
          var b = B.byId(s.id);
          return '<fieldset class="b-slot" data-duo-slot="' + i + '" style="border:0;margin:0;background:#fff;border-radius:32px;padding:22px;min-width:0">' +
            '<legend class="b-vh">Monstre ' + (i + 1) + '</legend>' +
            '<p style="margin:0 0 14px;display:flex;align-items:center;gap:10px;font-weight:700"><span data-duo-dot style="width:30px;height:30px;border-radius:50%;background:' + esc(b.hex) + ';display:grid;place-items:center;font-size:14px">' + (i + 1) + '</span>Monstre n° ' + (i + 1) + ' : <span data-duo-nom>' + esc(b.nom) + '</span></p>' +
            '<div style="display:flex;gap:10px;flex-wrap:wrap;margin-bottom:16px">' + BAND.map(function (c) {
              return '<button type="button" class="b-swatch" data-duo-color="' + esc(c.id) + '" aria-label="' + esc(c.nom) + '" aria-pressed="false" title="' + esc(c.nom) + '" style="position:relative;width:46px;height:46px;padding:0;border:0;border-radius:50%;background:transparent;cursor:pointer"><span aria-hidden="true" style="position:absolute;inset:3px;border-radius:50%;background:' + esc(c.hex) + ';filter:url(#fluff)"></span></button>';
            }).join('') + '</div>' +
            '<div style="display:grid;grid-template-columns:repeat(' + Math.min(5, SIZES.length || 5) + ',1fr);gap:6px">' + SIZES.map(function (z) {
              return '<button type="button" class="b-slot-size" data-duo-size="' + esc(z) + '" aria-pressed="false">' + esc(z) + '</button>';
            }).join('') + '</div>' +
            '<p data-duo-err role="alert" hidden style="margin:10px 0 0;font-size:14px;font-weight:700;color:#A8261D">Il lui faut une taille.</p>' +
            '</fieldset>';
        }).join('');
        B.initMascots(heads);
        sync();
      }
      function sync() {
        el.querySelector('[data-duo-title]').textContent = n === 2 ? 'ton duo.' : 'ta bande.';
        qsa('[data-duo-mode]', el).forEach(function (m) { m.setAttribute('aria-checked', Number(m.getAttribute('data-duo-mode')) === n ? 'true' : 'false'); });
        slots.slice(0, n).forEach(function (s, i) {
          var b = B.byId(s.id), fs = box.querySelector('[data-duo-slot="' + i + '"]'), head = heads.querySelector('[data-duo-head="' + i + '"]');
          if (!fs) return;
          if (s.size && B.PRODUCT && !B.available(s.id, s.size)) s.size = null;
          B.recolor(head, b.hex, b.tuft);
          fs.querySelector('[data-duo-dot]').style.background = b.hex;
          fs.querySelector('[data-duo-nom]').textContent = b.nom;
          qsa('[data-duo-color]', fs).forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-duo-color') === s.id ? 'true' : 'false'); });
          qsa('[data-duo-size]', fs).forEach(function (z) {
            var val = z.getAttribute('data-duo-size'), out = !!(B.PRODUCT && !B.available(s.id, val));
            z.setAttribute('aria-pressed', val === s.size ? 'true' : 'false');
            if (out) { z.setAttribute('data-soldout', ''); z.title = 'Épuisé'; } else { z.removeAttribute('data-soldout'); z.removeAttribute('title'); }
          });
          var bad = tried && !s.size;
          fs.classList.toggle('is-error', bad);
          fs.querySelector('[data-duo-err]').hidden = !bad;
        });
        var P = B.CFG.prices || { solo: 4990 }, total = B.bundleTotal(n), saving = n * P.solo - total;
        el.querySelector('[data-duo-count]').textContent = n;
        el.querySelector('[data-duo-total]').textContent = fmt(total);
        el.querySelector('[data-duo-saving]').textContent = saving > 0 ? fmt(saving) + ' de moins qu’en solo' : '';
        el.querySelector('[data-duo-add]').textContent = n === 2 ? 'Ajouter le duo' : 'Ajouter la bande';
      }
      el.addEventListener('click', function (e) {
        var t = e.target.closest('[data-duo-mode]');
        if (t) { var k = Number(t.getAttribute('data-duo-mode')); if (k !== n) { n = k; build(); } return; }
        var fs = e.target.closest('[data-duo-slot]');
        if (fs) {
          var i = Number(fs.getAttribute('data-duo-slot'));
          if ((t = e.target.closest('[data-duo-color]'))) { slots[i].id = t.getAttribute('data-duo-color'); sync(); return; }
          if ((t = e.target.closest('[data-duo-size]'))) { if (t.hasAttribute('data-soldout')) return; slots[i].size = t.getAttribute('data-duo-size'); sync(); return; }
        }
        if ((t = e.target.closest('[data-duo-add]'))) {
          var active = slots.slice(0, n);
          if (active.some(function (s) { return !s.size; })) { tried = true; sync(); return; }
          tried = false; sync();
          B.cart.add(active.map(function (s) { return { id: s.id, size: s.size }; }), t).catch(function () {});
        }
      });
      build();
    });
  }

  /* ================= FICHE PRODUIT ================= */
  function initProduct(root) {
    qsa('[data-product]', root).forEach(function (el) {
      if (!once(el, 'product')) return;
      initGallery(el);
      var simple = el.querySelector('[data-product-form-simple]');
      if (simple) {
        simple.addEventListener('submit', function (e) {
          var id = (simple.querySelector('[name="id"]') || {}).value;
          if (!id) return;
          e.preventDefault();
          B.cart.add({ variant: id }, simple.querySelector('[type="submit"]')).catch(function () {});
        });
        return;
      }
      if (el.getAttribute('data-babines-mode') !== 'true') return;
      var BAND = B.BAND, SIZES = B.SIZES, P = B.CFG.prices || { solo: 4990, duo: 8990, bande: 12990 };
      var showOffers = el.getAttribute('data-show-offers') === 'true';
      var S = { color: el.getAttribute('data-color') || (BAND[0] || {}).id, offer: 1, size: null, extras: [] };
      var form = el.querySelector('[data-product-form]'), sizesBox = el.querySelector('[data-sizes]'), sizeErr = el.querySelector('[data-size-error]');
      var extrasBox = el.querySelector('[data-extras]'), noteEl = el.querySelector('[data-price-note]'), soloNote = noteEl ? noteEl.textContent : '';
      var snowCanvas = el.querySelector('[data-product-snow]');
      var defaultSize = SIZES.indexOf('M') >= 0 ? 'M' : SIZES[0];

      function soloPrice() { var v = B.variantFor(S.color, S.size || SIZES[0]); return v ? v.p : P.solo; }
      function offerPrice(n) { return n === 1 ? soloPrice() : n === 2 ? P.duo : P.bande; }
      function headsFor(n) {
        var ids = [S.color].concat(S.extras.map(function (x) { return x.id; }));
        var start = Math.max(0, BAND.findIndex(function (x) { return x.id === S.color; }));
        var out = [];
        for (var i = 0; i < n; i++) out.push(B.byId(ids[i] || BAND[(start + i) % BAND.length].id));
        return out;
      }
      function renderOffers() {
        qsa('[data-offer]', el).forEach(function (btn) {
          var n = Number(btn.getAttribute('data-offer'));
          btn.setAttribute('aria-checked', S.offer === n ? 'true' : 'false');
          btn.querySelector('[data-offer-heads]').innerHTML = headsFor(n).map(function (h) {
            return '<span style="width:34px;height:34px;margin:0 -5px;display:block">' + B.mascotSVG(h.hex, h.tuft, '', false) + '</span>';
          }).join('');
        });
      }
      function renderExtras() {
        if (!extrasBox) return;
        extrasBox.hidden = S.extras.length === 0;
        extrasBox.innerHTML = S.extras.map(function (x, i) {
          var b = B.byId(x.id);
          return '<div data-extra="' + i + '"><p style="margin:0 0 8px;font-weight:700;font-size:14px">Monstre n° ' + (i + 2) + ' : <span style="font-weight:500">' + esc(b.nom) + ' · ' + esc(x.size) + '</span></p>' +
            '<div style="display:flex;gap:8px;flex-wrap:wrap;align-items:center">' +
            BAND.map(function (c) {
              return '<button type="button" class="b-swatch b-swatch--sm" data-extra-color="' + esc(c.id) + '" aria-label="' + esc(c.nom) + '" aria-pressed="' + (c.id === x.id ? 'true' : 'false') + '" title="' + esc(c.nom) + '" style="position:relative;width:36px;height:36px;padding:0;border:0;background:transparent;border-radius:50%;cursor:pointer"><span aria-hidden="true" style="position:absolute;inset:2px;border-radius:50%;background:' + esc(c.hex) + ';filter:url(#fluff)"></span></button>';
            }).join('') +
            '<span aria-hidden="true" style="width:1px;height:26px;background:#1C2140;opacity:.2;margin:0 4px"></span>' +
            SIZES.map(function (s) {
              var out = !B.available(x.id, s);
              return '<button type="button" class="b-xsize" data-extra-size="' + esc(s) + '" aria-pressed="' + (s === x.size ? 'true' : 'false') + '"' + (out ? ' data-soldout title="Épuisé"' : '') + '>' + esc(s) + '</button>';
            }).join('') + '</div></div>';
        }).join('');
      }
      function renderPrice() {
        var price = fmt(offerPrice(S.offer));
        qsa('[data-price]', el).forEach(function (n) { n.textContent = price; });
        if (noteEl) noteEl.textContent = S.offer === 1 ? soloNote : 'pour ' + S.offer + ' monstres · ' + fmt(S.offer * P.solo - offerPrice(S.offer)) + ' de moins';
        var lbl = el.querySelector('[data-add-label]');
        if (lbl) lbl.textContent = S.offer === 1 ? 'Ajouter au panier' : 'Ajouter les ' + S.offer + ' monstres';
      }
      function renderSizes() {
        qsa('[data-size]', sizesBox).forEach(function (btn) {
          var s = btn.getAttribute('data-size'), out = !B.available(S.color, s);
          btn.setAttribute('aria-checked', S.size === s ? 'true' : 'false');
          if (out) { btn.setAttribute('data-soldout', ''); btn.title = 'Épuisé'; } else { btn.removeAttribute('data-soldout'); btn.removeAttribute('title'); }
        });
        var lbl = el.querySelector('[data-size-label]'); if (lbl) lbl.textContent = S.size ? ': ' + S.size : '';
        var sel = el.querySelector('[data-sticky-size]'); if (sel) sel.value = S.size || '';
      }
      function syncVariant() {
        var v = B.variantFor(S.color, S.size);
        if (!v) { for (var i = 0; i < SIZES.length && !v; i++) { var c = B.variantFor(S.color, SIZES[i]); if (c && c.a) v = c; } }
        if (!v) v = B.variantFor(S.color, SIZES[0]);
        if (!v) return;
        var input = el.querySelector('[data-variant-id]'); if (input) input.value = v.id;
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }
      function sizeError(msg) { sizeErr.textContent = msg || ''; sizesBox.classList.toggle('is-error', !!msg); }
      function pickSize(s) {
        if (s && !B.available(S.color, s)) { S.size = null; renderSizes(); sizeError('Épuisé dans cette taille pour l’instant.'); return; }
        S.size = s || null; sizeError(''); renderSizes(); renderPrice(); syncVariant();
      }
      function pickColor(id, scrollTop) {
        var b = B.byId(id); S.color = b.id; el.setAttribute('data-color', b.id);
        if (S.size && !B.available(S.color, S.size)) S.size = null;
        qsa('[data-swatch]', el).forEach(function (sw) { sw.setAttribute('aria-checked', sw.getAttribute('data-swatch') === b.id ? 'true' : 'false'); });
        qsa('[data-b-nom]').forEach(function (n) { n.textContent = b.nom; });
        qsa('[data-b-line]').forEach(function (n) { n.textContent = b.line; });
        qsa('[data-b-hello]').forEach(function (n) { n.textContent = b.hello; });
        qsa('[data-b-deep]').forEach(function (n) { n.style.color = b.deep; });
        qsa('[data-b-hex-bg]').forEach(function (n) { n.style.background = b.hex; });
        qsa('[data-b-icons] .b-acc-ico').forEach(function (n) { n.style.background = b.hex; });
        qsa('[data-other]').forEach(function (a) { a.hidden = a.getAttribute('data-other') === b.id; });
        document.body.style.background = b.soft;
        var main = el.querySelector('[data-slide-main]'); if (main) main.style.background = b.soft;
        qsa('[data-color-slide]', el).forEach(function (sl) { sl.hidden = sl.getAttribute('data-color-slide') !== b.id; });
        if (snowCanvas && snowCanvas._snow) snowCanvas._snow.setColors([b.hex, '#FFFFFF', '#F4978E']);
        if (el._gallery) el._gallery.reset();
        renderOffers(); renderExtras(); renderSizes(); renderPrice(); syncVariant();
        if (scrollTop) window.scrollTo({ top: 0, behavior: B.reduced() ? 'auto' : 'smooth' });
      }
      function setOffer(n) {
        var used = [S.color], extras = [];
        for (var i = 0; i < n - 1; i++) {
          var prev = S.extras[i], id = prev ? prev.id : null;
          if (!id) { for (var j = 0; j < BAND.length; j++) if (used.indexOf(BAND[j].id) < 0) { id = BAND[j].id; break; } }
          if (!id) id = BAND[0].id;
          used.push(id);
          var size = prev ? prev.size : (S.size || defaultSize);
          if (!B.available(id, size)) { for (var k = 0; k < SIZES.length; k++) if (B.available(id, SIZES[k])) { size = SIZES[k]; break; } }
          extras.push({ id: id, size: size });
        }
        S.offer = n; S.extras = extras;
        renderOffers(); renderExtras(); renderPrice();
      }
      function addToCart(origin) {
        if (!S.size) { sizeError('Choisis ta taille d’abord. Les monstres sont tatillons.'); return false; }
        B.cart.add([{ id: S.color, size: S.size }].concat(S.extras), origin).catch(function () {});
        return true;
      }

      el.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-swatch]'))) { pickColor(t.getAttribute('data-swatch')); return; }
        if ((t = e.target.closest('[data-offer]'))) { setOffer(Number(t.getAttribute('data-offer'))); return; }
        if ((t = e.target.closest('[data-size]')) && sizesBox.contains(t)) { pickSize(t.getAttribute('data-size')); return; }
        var ex = e.target.closest('[data-extra]');
        if (ex) {
          var i = Number(ex.getAttribute('data-extra'));
          if ((t = e.target.closest('[data-extra-color]'))) {
            S.extras[i].id = t.getAttribute('data-extra-color');
            if (!B.available(S.extras[i].id, S.extras[i].size)) { for (var k = 0; k < SIZES.length; k++) if (B.available(S.extras[i].id, SIZES[k])) { S.extras[i].size = SIZES[k]; break; } }
            renderExtras(); renderOffers(); focusExtra(i, '[data-extra-color="' + S.extras[i].id + '"]'); return;
          }
          if ((t = e.target.closest('[data-extra-size]'))) {
            if (t.hasAttribute('data-soldout')) return;
            S.extras[i].size = t.getAttribute('data-extra-size'); renderExtras(); focusExtra(i, '[data-extra-size="' + S.extras[i].size + '"]'); return;
          }
        }
        if ((t = e.target.closest('[data-add-sticky]'))) {
          if (!addToCart(t)) { var sel = el.querySelector('[data-sticky-size]'); if (sel) sel.focus(); }
          return;
        }
      });
      function focusExtra(i, sel) { var n = extrasBox.querySelector('[data-extra="' + i + '"] ' + sel); if (n) n.focus({ preventScroll: true }); }
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(el.querySelector('[data-add-main]')); });
      var stickySel = el.querySelector('[data-sticky-size]');
      if (stickySel) stickySel.addEventListener('change', function () { pickSize(stickySel.value || null); });
      /* « Complète la bande » : change le coloris sans recharger la page */
      qsa('[data-other]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); pickColor(a.getAttribute('data-other'), true); });
      });

      /* Barre d'achat mobile : visible quand le bouton principal est sorti de l'écran par le haut */
      var sticky = el.querySelector('[data-sticky]'), cta = el.querySelector('[data-add-main]'), stickyQueued = false;
      function syncSticky() {
        stickyQueued = false;
        /* mesure directe plutôt qu'un IntersectionObserver : un saut de défilement (ancre, touche Fin) ne doit pas être manqué */
        sticky.hidden = !(isMobile() && cta.getBoundingClientRect().bottom <= 0);
      }
      function queueSticky() { if (!stickyQueued) { stickyQueued = true; requestAnimationFrame(syncSticky); } }
      if (sticky && cta) {
        window.addEventListener('scroll', queueSticky, { passive: true });
        window.addEventListener('resize', queueSticky);
        syncSticky();
      }

      /* Panneau « Trouver ma taille » */
      var guide = el.querySelector('[data-guide]'), gOverlay = el.querySelector('[data-guide-overlay]'), gOpener = null;
      if (guide) {
        var limits = limitsOf(guide.getAttribute('data-guide-limits')), hInput = guide.querySelector('[data-guide-height]'), gGuess = guide.querySelector('[data-guide-guess]');
        var guess = function () { return SIZES[Math.min(guessIndex(Number(hInput.value), limits), SIZES.length - 1)] || ''; };
        var closeGuide = function () { if (guide.hidden) return; guide.hidden = true; gOverlay.hidden = true; if (gOpener) gOpener.focus({ preventScroll: true }); };
        hInput.addEventListener('input', function () { gGuess.textContent = guess(); });
        gGuess.textContent = guess();
        qsa('[data-guide-open]', el).forEach(function (b) { b.addEventListener('click', function () { gOpener = b; guide.hidden = false; gOverlay.hidden = false; hInput.focus({ preventScroll: true }); }); });
        qsa('[data-guide-close]', guide).forEach(function (b) { b.addEventListener('click', closeGuide); });
        gOverlay.addEventListener('click', closeGuide);
        window.addEventListener('babines:escape', closeGuide);
        guide.querySelector('[data-guide-apply]').addEventListener('click', function () { var g = guess(); closeGuide(); pickSize(g); });
      }

      renderOffers(); renderSizes(); renderPrice();
      if (!showOffers) S.offer = 1;
    });
  }

  /* Galerie : défilement horizontal aimanté, vignettes, zoom au survol (ordinateur) */
  function initGallery(el) {
    var track = el.querySelector('[data-gallery-track]'), thumbsBox = el.querySelector('[data-gallery-thumbs]');
    if (!track || !thumbsBox) return;
    var slides = qsa('[data-slide]', track), current = 0;
    function thumbFor(slide, i) {
      var soft = slide.hasAttribute('data-slide-main') ? slide.style.background : '#D8E8F4', inner = '', label = 'Vue ' + (i + 1);
      if (slide.hasAttribute('data-slide-video')) { inner = '<span>Vidéo</span>'; label = 'Vidéo'; }
      else {
        var scope = slide.querySelector('[data-color-slide]:not([hidden])') || slide;
        var img = scope.querySelector('img');
        if (img) { inner = '<img src="' + esc(img.currentSrc || img.src) + '" alt="" style="object-position:' + esc(img.style.objectPosition || 'center') + '">'; label = img.alt || label; }
        else { var svg = scope.querySelector('svg[data-mascot]'); if (svg) { var c = B.byId(el.getAttribute('data-color')); inner = '<span style="width:70%;height:70%;display:block">' + B.mascotSVG(c.hex, c.tuft, '', false) + '</span>'; } }
        if (i === 0) label = 'Photo principale';
      }
      return '<button type="button" class="b-thumb" data-thumb="' + i + '" aria-label="' + esc(label) + '"' + (i === current ? ' aria-current="true"' : '') + ' style="background:' + esc(soft || '#D8E8F4') + '">' + inner + '</button>';
    }
    function renderThumbs() { thumbsBox.innerHTML = slides.length > 1 ? slides.map(thumbFor).join('') : ''; }
    function mark() { qsa('[data-thumb]', thumbsBox).forEach(function (t, i) { if (i === current) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); }); }
    function go(i, instant) { current = i; mark(); track.scrollTo({ left: track.clientWidth * i + 12 * i, behavior: instant || B.reduced() ? 'auto' : 'smooth' }); }
    thumbsBox.addEventListener('click', function (e) { var t = e.target.closest('[data-thumb]'); if (t) go(Number(t.getAttribute('data-thumb'))); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / (track.clientWidth + 12));
      if (i !== current) { current = i; mark(); }
    }, { passive: true });
    qsa('[data-zoom]', track).forEach(function (z) {
      var img = z.querySelector('img'); if (!img) return;
      z.addEventListener('mousemove', function (e) {
        if (isMobile()) return;
        var r = z.getBoundingClientRect();
        img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100).toFixed(1) + '% ' + ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        img.style.transform = 'scale(2)';
      });
      z.addEventListener('mouseleave', function () { img.style.transform = 'scale(1)'; img.style.transformOrigin = '50% 50%'; });
    });
    el._gallery = { reset: function () { current = 0; renderThumbs(); track.scrollTo({ left: 0, behavior: B.reduced() ? 'auto' : 'smooth' }); } };
    renderThumbs();
  }

  B.register(function (root) {
    initThermo(root); initAnatomy(root); initForms(root); initFaq(root); initTailles(root); initBande(root); initDuo(root); initProduct(root);
  });
})();
